import React from 'react'
import classNames from 'classnames'
import { LocaleTypes } from '../types'
import { Link } from 'react-router-dom'
import logo from './../assets/logo.svg'

const getFlagStyle = (country: string) => ({
	backgroundImage: `url(https://shop.futurestorearnhem.nl/_futurestore/img/language-icons/${country}.svg)`,
})

interface HeaderProps {
	locale: LocaleTypes
	setLocale: (locale: LocaleTypes) => void
}

const Header: React.FC<HeaderProps> = props => {
	return (
		<header className="background background--white background--border-bottom">
			<div className="grid">
				<div className="grid__row grid__row--gutter-2x grid__row--vertical-align">
					<div className="grid__col grid__col--6">
						<Link to="/" className="logo logo--header" href="/"><img src={logo} alt="Future Store Arnhem" /></Link>
					</div>
					<div className="grid__col grid__col--6">
						<div className="language language--flex">
							<span
								onClick={() => props.setLocale('en')}
								className={classNames('language__icon', {
									'language__icon--active': props.locale === 'en',
								})}
								style={getFlagStyle('united-kingdom')}
							>
								<span className="fal fa-angle-up" aria-hidden="true"></span>
							</span>
							<span
								onClick={() => props.setLocale('nl')}
								className={classNames('language__icon', {
									'language__icon--active': props.locale === 'nl',
								})}
								style={getFlagStyle('netherlands')}
							>
								<span className="fal fa-angle-up" aria-hidden="true"></span>
							</span>
							<span
								onClick={() => props.setLocale('de')}
								className={classNames('language__icon', {
									'language__icon--active': props.locale === 'de',
								})}
								style={getFlagStyle('germany')}
							>
								<span className="fal fa-angle-up" aria-hidden="true"></span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</header>
	)
}

export default Header
